const translations = {
    logoutNotVerified: 'Back to Sign Up',
    logoutVerified: 'Log out',
    notVerifiedMessage: 'Made a mistake?',
    verifiedMessage: 'Not ready to complete your account set up?'
};

export default translations;
